<template>
    <div>
        <h4 :id="id" class="custom-ui header"
            :style="hasExtension ? 'margin-bottom: 0;' : ''" v-text="text">
        </h4>
        <i tabindex="0" v-if="$tb('common.label.brandDesc') !== 'common.label.brandDesc'" id="brand-description"
           class="blue question circle icon link" :data-content="$tb('common.label.brandDesc')"
           :aria-label="$tb('common.label.brandDesc')"
           data-variation="wide"></i>
        <div v-if="hasExtension">
            <h4 id="header-extension" class="custom-ui header" style="margin-top: -8px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;">
                {{ $tb('common.label.headerExtension') }}
                <div v-if="hasLogo" class="ciam-brand-logo"></div>
            </h4>
        </div>
    </div>
</template>

<script>
import { mixin } from '../js/ciam-mixin.js'

export default {
  mixins: [mixin],
  props: {
    id: {
      type: String,
      default: ''
    },
    text: {
      type: String
    },
    hasExtension: {
      type: Boolean,
      default: false
    },
    hasLogo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
    .ciam-brand-logo {
        display: inline-block;
        height: 40px;
        width: 40px;
        background-image: none;
        background-size: cover;
        background-position: center;
        vertical-align: sub;
    }
    .brand-desc {
      text-align: center;
    }
</style>
